import { BrowserQRCodeReader } from '@zxing/browser'
import { BarcodeFormat, ChecksumException, DecodeHintType, NotFoundException } from '@zxing/library'

const codeReader = new BrowserQRCodeReader()
codeReader.hints.set(DecodeHintType.POSSIBLE_FORMATS, [BarcodeFormat.QR_CODE])
codeReader.hints.set(3, true)

let retry = 0
const degrees = [90, 180, 270, 345]

export const fileReader = new FileReader()

const retryReadQRCode = async (image, ctx, width, height, canvas) => {
  while (true) {
    try {
      ctx.clearRect(0, 0, canvas.width, canvas.height)
      ctx.save()
      ctx.translate(canvas.width / 2, canvas.height / 2)
      ctx.rotate((degrees[retry] * Math.PI) / 180)
      ctx.drawImage(image, -width / 2, -height / 2)
      ctx.restore()
      const result = await codeReader.decodeFromCanvas(canvas)
      return result.getText()
    } catch (error) {
      if (error instanceof ChecksumException || error instanceof NotFoundException) {
        retry++
        if (retry >= degrees.length) {
          return ''
        }
      } else {
        console.error(error)
        return ''
      }
    }
  }
}

// url refer to object url create from URL.createObjectURL(f File)
const readQRCode = async (url = '') => {
  const image = new Image()
  image.src = url
  try {
    const result = await codeReader.decodeFromImageElement(image)
    return result.getText()
  } catch (error) {
    try {
      const { width, height } = calculateImageSize(image.width, image.height)
      const canvas = document.createElement('canvas')
      const ctx = canvas.getContext('2d', { willReadFrequently: true })
      canvas.width = width
      canvas.height = height
      ctx?.drawImage(image, 0, 0, width, height)
      try {
        const result = await codeReader.decodeFromCanvas(canvas)
        return result.getText()
      } catch (CheckSumException) {
        retry = 0
        const result = await retryReadQRCode(image, ctx, width, height, canvas)
        return result
      }
    } catch (err) {
      console.error(err)
      return ''
    }
  }
}

const subtag = ['00', '00060000010103', '02', '5102TH91']

const getTransRef = (qr) => {
  if (qr.length < 25) {
    return ''
  }

  const hardcodeTextString = qr.substring(4, 18)
  if (qr.substring(0, 2) !== subtag[0] || hardcodeTextString !== subtag[1] || qr.substring(21, 23) !== subtag[2]) {
    return ''
  }

  const payloadLength = Number(qr.substring(2, 4))

  if (qr.substring(4 + payloadLength, 12 + payloadLength) !== subtag[3]) {
    return ''
  }

  const transRefLength = Number(qr.substring(23, 25))

  return qr.substring(25, 25 + transRefLength)
}

export const getQRCodeData = async (url = '') => {
  const qr = await readQRCode(url)
  if (!getTransRef(qr)) {
    return ''
  }
  return qr
}

export const calculateImageSize = (width, height) => {
  const MAX_WIDTH = 1280
  const MAX_HEIGHT = 1280

  if (width > height) {
    if (width > MAX_WIDTH) {
      height = height * (MAX_WIDTH / width)
      width = MAX_WIDTH
    }
  } else {
    if (height > MAX_HEIGHT) {
      width = width * (MAX_HEIGHT / height)
      height = MAX_HEIGHT
    }
  }
  return { width, height }
}
